import React, { useEffect, useState } from 'react';
import { Typography, Grid, withStyles } from '@material-ui/core';
import { useParams, useHistory } from 'react-router-dom';
import PageWrapper from 'components/ui/PageWrapper';
import { setSuspensionWarningMessage } from 'utils/suspensions';
import AccountDetails from './AccountDetailsPreview';
import SuspensionRules from './SuspensionRulesPreview';
import PleaseNote from './PleaseNotePreview';
import FormErrorAlert from './common/FormErrorAlert';

const styles = (theme) => ({
  item1: {
    [theme.breakpoints.up('lg')]: {
      order: 1,
    },
    order: 2,
  },
  item2: {
    [theme.breakpoints.up('lg')]: {
      order: 2,
    },
    order: 1,
  },
  nameHead: {
    padding: '15px 0px 33px 0px',
    fontSize: '32px',
  },
});

const SuspensionLayout = (props) => {
  const [errorMsg, setErrorMsg] = useState('');
  const {
    title,
    getPersonalInfo,
    getBalanceToSettle,
    customerDetails,
    suspensionInfo,
    localisation,
    updateAppLoading,
    canChargeForSuspension,
    hasSuspensionRuleForAccount,
    suspensionRuleLoading,
    canSuspendIgnoreSuspensionRules,
    canManageSuspensions,
    classes,
  } = props;

  const { adfitNo } = useParams();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      await Promise.all([
        getPersonalInfo(adfitNo),
        getBalanceToSettle(adfitNo),
      ]);
    })();
  }, [
    adfitNo,
    getPersonalInfo,
    getBalanceToSettle,
    canSuspendIgnoreSuspensionRules,
  ]);
  //if no permission, redirect user to payments page
  useEffect(() => {
    if (!canManageSuspensions && !canSuspendIgnoreSuspensionRules) {
      setSuspensionWarningMessage();
      history.push(`/Customers/${adfitNo}/Payments/Suspensions`);
    }
  }, [canManageSuspensions, canSuspendIgnoreSuspensionRules, adfitNo, history]);

  const accountDetails = {
    billNext: customerDetails.billNext,
    finishDate: customerDetails.finishDate,
    startDate: customerDetails.startDate,
    numOfTerm: customerDetails.numOfTerm,
    termType: customerDetails.termType,
    balanceToSettle: customerDetails.balanceToSettle,
  };

  return (
    <PageWrapper>
      <FormErrorAlert errorMsg={errorMsg} setErrorMsg={setErrorMsg} />
      <Grid container className={classes.nameHead} justify="space-between">
        <Grid>
          <Typography variant="h2">{title}</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={6}>
        <Grid item xs={12} lg={6} className={classes.item1}>
          <Grid container direction="column" justify="flex-start" spacing={3}>
            <Grid item xs={12}>
              {React.cloneElement(props.children, {
                canSuspendIgnoreSuspensionRules,
                setErrorMsg,
                suspensionInfo,
                localisation,
                hasSuspensionRuleForAccount,
                updateAppLoading,
                canChargeForSuspension,
                accountDetails,
              })}
            </Grid>
            <Grid item>
              <PleaseNote localisation={localisation} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} lg={6} className={classes.item2}>
          <Grid container direction="column" justify="flex-start" spacing={3}>
            {hasSuspensionRuleForAccount ? (
              <Grid item>
                <SuspensionRules
                  {...{ localisation, suspensionInfo, suspensionRuleLoading }}
                />
              </Grid>
            ) : null}
            <Grid item>
              <AccountDetails {...{ localisation, accountDetails }} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </PageWrapper>
  );
};

export default withStyles(styles)(SuspensionLayout);
